// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4ef6ed4e","271":"ed9d5408","301":"674c980e","393":"81a700a5","424":"76b01ca6","501":"65379dd4","746":"858c6584","941":"02d8929c","970":"46b83414"}[chunkId] + ".chunk.js";
};